import { useMutation, useQueryClient } from 'react-query';

import useApiHelper from '../../../hooks/useApiHelper';

import { useDefaultMutateResponseHandlers } from '../../../hooks/useDefaultMutateResponeHandlers';
import {
  IFaultAction,
  IFaultActionCreateRequest,
  IFaultActionDeleteRequest,
} from '../../../types/Fault/FaultCause';
import { faultQueryKeys } from '../../QueryKeys';

export default function useSuperAdminFaultActionMutations() {
  const queryClient = useQueryClient();
  const { post, put, del } = useApiHelper();
  const { handleSuccess, handleError } =
    useDefaultMutateResponseHandlers('Fault Action');

  const createFaultAction = useMutation({
    mutationFn: (faultAction: IFaultActionCreateRequest) =>
      post('/v1/superadmin/fault/actions', faultAction),
    onError: (error) => handleError(error, 'create'),
    onSuccess: (data) => handleSuccess(data, 'create'),
    onSettled: () =>
      queryClient.invalidateQueries(faultQueryKeys.superAdminActions()),
  });

  const updateFaultAction = useMutation({
    mutationFn: (faultAction: IFaultAction) =>
      put<IFaultAction>(
        `/v1/superadmin/fault/actions/${faultAction.id}`,
        faultAction
      ),
    onError: (error) => handleError(error, 'update'),
    onSuccess: (data) => handleSuccess(data, 'update'),
    onSettled: () =>
      queryClient.invalidateQueries(faultQueryKeys.superAdminActions()),
  });

  const delFaultAction = useMutation({
    mutationFn: (faultAction: IFaultActionDeleteRequest) =>
      del(`/v1/superadmin/fault/actions/${faultAction.id}`),
    onError: (error) => handleError(error, 'delete'),
    onSuccess: (data) => handleSuccess(data, 'delete'),
    onSettled: () =>
      queryClient.invalidateQueries(faultQueryKeys.superAdminActions()),
  });

  return {
    createFaultAction,
    updateFaultAction,
    delFaultAction,
  };
}
